module.exports = __webpack_public_path__ + "media/components/country-flag/static/gq-341837d8128634abab094a1d8575bc74.svg";